import React, { useState } from "react";
import {
  ContactFormWrapper,
  ContactFormLabel,
  ContactFormElementInput,
  ContactFormElementTextarea,
  ContactFormElementSubmit,
} from "./ContactElements";

const ContactForm = () => {
  const GOOGLE_FORM_URL =
    "https://docs.google.com/forms/d/e/1FAIpQLSdEPVTESOGJhpcsgGlMwlc_moCGl19PbyWykU2CtEn4wd_PHg/formResponse";

  const formValuesInitState = { name: "", email: "", message: "" };
  const [formValues, setFormValues] = useState(formValuesInitState);
  const [hasSendEmail, setHasSendEmail] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formValues.email || !formValues.name) return;

    const formData = new FormData();
    formData.append("entry.1803340898", formValues.name);
    formData.append("entry.662671763", formValues.email);
    formData.append("entry.1644283035", formValues.message);

    await fetch(GOOGLE_FORM_URL, { method: "POST", body: formData, mode: "no-cors" });
    setFormValues(formValuesInitState);
    setHasSendEmail(true);
  };

  const handleChange = (e) =>
    setFormValues({ ...formValues, [e.target.name]: e.target.value });

  const submitButtonText = hasSendEmail ? "We will contact you soon!" : "Submit";

  return (
    <ContactFormWrapper id="contact-form" onSubmit={handleSubmit}>
      <ContactFormLabel htmlFor="name">Name</ContactFormLabel>
      <ContactFormElementInput
        id="name"
        type="text"
        name="name"
        value={formValues.name}
        onChange={handleChange}
      />

      <ContactFormLabel htmlFor="email">Email address</ContactFormLabel>
      <ContactFormElementInput
        id="email"
        type="email"
        name="email"
        value={formValues.email}
        onChange={handleChange}
      />

      <ContactFormLabel htmlFor="message">Message</ContactFormLabel>
      <ContactFormElementTextarea
        id="message"
        name="message"
        placeholder="Your message..."
        value={formValues.message}
        onChange={handleChange}
      />

      <ContactFormElementSubmit type="submit">
        {submitButtonText}
      </ContactFormElementSubmit>
    </ContactFormWrapper>
  );
};

export default ContactForm;
